/* Rocket scroll effect — scroll-position-linked launch using the existing
   logo badge. Ported unchanged from the earlier build (self-contained,
   no theme-specific dependencies). Reduced-motion respected, one broken
   bit can't hide anything else, re-runs on section load in the editor. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  function init(root) {
    (root || document).querySelectorAll('[data-bt-rocket]:not([data-bt-rocket-init])').forEach(function (track) {
      track.setAttribute('data-bt-rocket-init', '');
      var img = track.querySelector('[data-bt-rocket-img]');
      var flame = track.querySelector('[data-bt-rocket-flame]');
      if (!img) return;

      var ticking = false;

      function render() {
        ticking = false;
        var rect = track.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var travel = rect.height - vh;
        if (travel <= 0) return;
        var raw = -rect.top / travel;
        var p = Math.min(1, Math.max(0, raw));

        var rise = p * 78;
        var drift = Math.sin(p * Math.PI) * 6;
        var tilt = -6 + (p * 6);
        img.style.transform =
          'translate(calc(-50% + ' + drift.toFixed(2) + 'vw), -' + rise.toFixed(2) + 'vh) rotate(' + tilt.toFixed(2) + 'deg)';

        if (flame) {
          var flameOpacity = Math.sin(p * Math.PI);
          var stretch = 0.6 + p * 1.1;
          flame.style.transform =
            'translate(calc(-50% + ' + drift.toFixed(2) + 'vw), -' + rise.toFixed(2) + 'vh) scaleY(' + stretch.toFixed(2) + ')';
          flame.style.opacity = flameOpacity.toFixed(2);
        }
      }

      function onScroll() {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(render);
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      render();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
